module.exports = __webpack_public_path__ + "fonts/iconfont.8528683.eot";